import FollowUpAgenciamentoConsultPageBase from './FollowUpAgenciamentoConsultPageBase';
import { FOLLOWUP_FILTROS } from '../followUpAgenciamentoFixedFilters';

export default function FollowUpAgenciamentoConsultExportMaritimoPage(props) {
  return (
    <FollowUpAgenciamentoConsultPageBase
      {...props}
      filtrosFixos={FOLLOWUP_FILTROS.EXPORT_MARITIMO}
      urlNovo="/exportacao/agenciamento/maritimo/follow-up/registro/novo"
      urlDetalhes={(id) => `/exportacao/agenciamento/maritimo/follow-up/${id}/detalhes`}
      urlLista={(id) => `/exportacao/agenciamento/maritimo/follow-up/${id}/lista`}
      breadcrumbModulo={{
        name: 'Exportação Agenciamento Marítimo',
        to: '/exportacao/agenciamento/maritimo',
      }}
    />
  );
}
